import {createSlice} from "@reduxjs/toolkit";

/**
 * UI control Slice
 * - to avoid complicated props passing, this slice
 * contains states for controlling UI elements
 */
const initialState = {
  openVerticalNavBar: true,
};

const uiControlSlice = createSlice({
  name: "uiControl",
  initialState,

  reducers: {
    setOpenVerticalNavBar: (state, action) => {
      state.openVerticalNavBar = action.payload;
    },
  },
});

export const {setOpenVerticalNavBar} = uiControlSlice.actions;

export default uiControlSlice.reducer;
